<template>
	<div class="input__wrapper" v-on-click-outside="hideValue">
		<label :class="data.labelClass">
			<span class="input-label" :id="data.labelId">{{ data.label }}<span class="input__wrapper-mandatory" v-if="data.mandatoryFiled">*</span></span>
			
			<div class="input__autocomplete" ref="autocompleteInput">
				<input
					autocomplete="off"
					v-model="input"
					:type="data.type"
					:id="data.inputId"
					:placeholder="data.placeholder"
					:list="filteredList"
					@input="handleInput"
					@blur="hideValue"
					@focus="showValue()"
				>
				<div class="input__autocomplete-wrap" v-if="valueInput">
					<div v-if="input">
						<ul class="input__autocomplete-list">
							<li class="input__autocomplete-item" v-for="(item, i) in list" :key="i" @click="setInput(item)">
								{{ item }}
							</li>
						</ul>
					</div>
				</div>
			</div>
		</label>
	</div>
</template>

<script>
import { mixin as onClickOutside } from 'vue-on-click-outside';
export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			input: null,
			valueInput: false,
			list: [
				'Brooklyn',
				'Queens'
			]
		};
	},
	mixins: [onClickOutside],
	watch: {
		inputVal (val) {
			this.$emit('input', val);
		}
	},
	computed: {
		filteredList() {
			if (this.filterInput) {
				return this.list.filter(e => e.toLowerCase().indexOf(this.filterInput.toLowerCase()) !== -1);
			} else {
				return this.list;
			}
		}
	},
	methods: {
		showValue() {
			this.valueInput = true;
		},
		hideValue() {
			this.valueInput = false;
		},
		handleInput(e) {
			this.$emit('input', e.target.value);
			this.filterInput = e;
		},
		setValue(value) {
			this.inputVal = value;
			this.showValue = true;
		},
		setInput(value) {
			this.input = value;
			this.$emit('input', value);
			this.valueInput = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.input__autocomplete {
	position: relative;
	z-index: 10;

	.show-value {
		opacity: 1;
		visibility: visible;
		max-height: 300px;
		height: 100%;
	}
}
.input__autocomplete-wrap {
	border: 1px solid $grey-light;
	position: absolute;
	top: 98%;
	width: 100%;
	max-width: 100%;
	background-color: $white;
}

.input__autocomplete-item {
	background-color: $white;
	display: block;
	padding: 16px;
	cursor: pointer;
	line-height: 1.2;
	font-size: 14px;
	font-family: $font-main;
	color: $fiord;
	transition: $dur $ease;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	position: relative;

	@include hover {
		background-color: #f5f5f5;
	}
}

.input__wrapper {
	input {
		display: block;
		box-shadow: none;
		border: 1px solid $white-lilac;
		border-radius: 14px;
		padding: 14px 16px;
		max-width: 100%;
		line-height: 1.2;
		width: 100%;
		font-size: 14px;
		font-family: $font-main;
		color: $fiord;
		transition: $dur $ease;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		background-color: $white-lilac;

		@include mq($sm) {
			font-size: 16px;
			padding: 13px;
		}

		&:focus {
			border: 1px solid $dodger-blue;
		}

		@include placeholder {
			color: $grey;
		}
	}
}
</style>
